import { SelectOption } from '@framework/form';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { parseAdvancedRichTextToString } from '../../../../../../validator';
import { IComponentOptions } from '../../../../WidgetOptionLogic';

/**
 * Data una lista di options, restituisce una struttura che, fornita a un SelectInput,
 * renderizza correttamente le options in caso di gruppi.
 */
export function parseOptionToSelect(
  options: IComponentOptions,
): SelectOption[] {
  if (!options) return [];
  if (options.type === 'flat') {
    return options.values.map(v => ({
      value: v.value,
      label: <RichTextAdvancedRender text={v.label} />,
      labelText: parseAdvancedRichTextToString(v.label),
      disabled: v.disabled,
    }));
  }

  if (options.type === 'grouped') {
    return options.options
      .map(o => ({
        label: <RichTextAdvancedRender text={o.label} />,
        key: o.label[0]?.text ?? o.options[0].value,
        options: o.options.map(v => ({
          label: <RichTextAdvancedRender text={v.label} />,
          labelText: parseAdvancedRichTextToString(v.label),
          value: v.value,
          disabled: v.disabled,
        })),
      }))
      .filter(g => g.options.length > 0);
  }

  console.warn(`[parseOptionToSelect] options type not supported`, {options}); // prettier-ignore
  return [];
}
